import { render, staticRenderFns } from "./showResult.vue?vue&type=template&id=2e567278&scoped=true&"
import script from "./showResult.vue?vue&type=script&lang=js&"
export * from "./showResult.vue?vue&type=script&lang=js&"
import style0 from "./showResult.vue?vue&type=style&index=0&id=2e567278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e567278",
  null
  
)

export default component.exports